import { BehaviorSubject } from 'rxjs';

export enum ServerErrorReason {
  /** The request failed for a reason the viewer can only retry. */
  TECHNICAL = 'TECHNICAL',
  /** The content is member only and the viewer is not logged in as a member. */
  MEMBER_REQUIRED = 'MEMBER_REQUIRED',
}

export interface ServerErrorState {
  isError: boolean;
  message: string;
  reason?: ServerErrorReason;
}

export const isServerError$ = new BehaviorSubject<ServerErrorState>({
  isError: false,
  message: '',
});

export const getIsServerError$ = () => isServerError$;

export const setIsServerError$ = (error: ServerErrorState) =>
  isServerError$.next(error);
